import { useQuery } from 'react-query';
import { CaseDetailsResponsePayloadDTO } from '@oh-vcp/components-common';
import { AxiosError } from 'axios';
import CaseService from './caseService';

const useCaseDetails = (caseId: number | undefined | null, onError?: (error: any) => void) => {
  return useQuery<CaseDetailsResponsePayloadDTO, AxiosError>(
    ['caseDetails', caseId],
    () => CaseService.getCaseDetails(caseId!),
    {
      enabled: !!caseId,
      refetchOnWindowFocus: false,
      retry: 0,
      cacheTime: 0,
      staleTime: 0,
      refetchOnMount: true,
      keepPreviousData: false,
      onError
    }
  );
};

export default useCaseDetails;
